module.exports = __webpack_public_path__ + "static/media/pmag-single.8b51d64b.png";